module.exports = __webpack_public_path__ + "28b67065/img/file-icon.c085e21e.svg";